<template>
     <div class="national">
        <div class='titlebg'>
            <div class="drawContent">
                <img src="@/assets/images/national/nationOne.png" alt="" class="bg">
                <img src="@/assets/images/national/draw.png" alt="" class="drawBtn" @click="getActivityDiscount()">
            </div>
            <div class="drawContent">
                <div class="btnBox">
                    <img src="@/assets/images/national/prize.png" alt=""  @click="goMyPrize()">
                    <img src="@/assets/images/national/rule.png" alt="" @click="showrule()" style="margin-left:0.21rem;">
                </div>
                <div class="prizeBox">
                    <div class="prize " v-for="item in prizeList" :class="[showID==item.id?'active':'']" >
                        <div >
                            <img :src="item.imgUrl" alt=""  @click="godraw(item.id,adclick)" >
                        </div>
                    </div>
                </div>
                <p class="chance">还有{{luckDrawNum}}次抽奖机会</p>
                <div class="share" @click="shareLuckDraw()">
                    <img src="@/assets/images/national/share.png" alt="">
                </div>
                <img src="@/assets/images/national/nationTwo.png" alt="" class="bg">
            </div>
            <img src="@/assets/images/national/nationThree.png" alt="" class="bg" >
        </div>
        <!-- 活动规则 -->
        <div class="mantle" v-if="activeShow" >
            <div class="mengmeng" @click="colseMeng()"></div>
            <div class='mantleDetail'>
                <div style="padding:0.4rem 0.4rem;">
                    <p>活动规则：</p>
                    <div>1. 2020年中秋及国庆假期订单即日起接受预定。</div>
                    <div>2. 优惠券使用规则：</div>
                    <div>
                        <p>① 120元、180元、270元优惠券、无门槛优惠券均适用于租期在2020年9月30日-10月8日内的订单；</p>
                        <p>②120元优惠券适用于租期在2020年9月30日-10月8日内且租满5天（含）及以上的订单；</p>
                        <p>③180元优惠券适用于租期在2020年9月30日-10月8日内且租满7天（含）及以上的订单；</p>
                        <p>④270元优惠券适用于租期在2020年9月30日-10月8日内且租满9天（含）及以上的订单；</p>
                        <p>⑤抽奖所得的5元、10元、20元、30元无门槛优惠券可与120元、180元、270元优惠券叠加使用，单笔订单最多叠加使用1张无门槛券；</p>
                        <p>⑥参与【免费用车周周送】活动所得的周周免费用车券适用于取还车时间在2020年10月10日-11月28日且租期≥3天的订单，单笔订单可使用1张免费用车券，即减免1天车辆租金（最高减免100元），活动期间最多减免7笔订单共计7天车辆租金（最高减免共计700元）。</p>
                    </div>
                    <div>3. 优惠金额为车辆日租金，领券后由系统自动减免，其他费用正常收取。</div>
                </div>
            </div>
        </div>
        <!-- 抽奖规则 -->
        <div  class="mantle" v-if="ruleshow">
            <div class="mengmeng" @click="closerule()"></div>
            <div class="mantleDetail">
                <div style="padding:0.4rem 0.4rem;">
                    <p>抽奖规则：</p>
                    <div>1. 活动时间：即日起至2020年10月8日。</div>
                    <div>2. 每人有2次抽奖机会，分享抽奖活动页面1次，即多获得1次抽奖机会，抽奖次数不限。</div>
                    <div>3.活动奖品：</div>
                    <div>
                        <p>① 5元、10元、20元、30元无门槛优惠券均适用于租期包含2020年9月30日-10月8日的订单；</p>
                        <p>②无门槛优惠券可与120元、180元、270元优惠券叠加使用；</p>
                        <p>③单笔订单最多叠加使用1张无门槛券。</p>
                    </div>
                    <div>4. 如有疑问请拨打客服电话：400-666-8818。</div>
                    </div>
            </div>  
        </div>
        <div class="activeRule" @click="goactive()">
            <img src="https://cms.dafang24.com/aliapp/20200825/activeRule.png" alt="">
        </div>
        
    </div>
</template>
<script>
 import { apiMode, resourceUrl, orderSource,mySelfURL } from "@/utils/env";
  import {
    getConsumerCoupons, //获取用户优惠券
    DrawCoupon, //领取优惠券
    luckDrawInit, //获取抽奖活动信息
    getLotteryCount, //获得当前抽奖次数
    addLotteryCount, //增加抽奖次数
    luckDraw, //开始抽奖
    getCurrentMemberInfo, //获取用户信息
  } from '@/utils/api'
export default {
    data(){
        return{
            prizeList:[
                {  
                    id:"1",
                    name: "5元无门槛券",
                    OfferID: "0",
                    imgUrl:"https://cms.dafang24.com/aliapp/20200825/five.png",
                },
                {  
                    id:"2",
                    name: "谢谢参与",
                    OfferID:"" ,
                    imgUrl:"https://cms.dafang24.com/aliapp/20200825/join.png"
                },
                {  
                    id:"3",
                    name: "20元无门槛券",
                    OfferID: "0",
                    imgUrl:"https://cms.dafang24.com/aliapp/20200825/twenty.png"
                },
                {  
                    id:"8",
                    name: "10元无门槛券",
                    OfferID: "0",
                    imgUrl:"https://cms.dafang24.com/aliapp/20200825/ten.png"
                },
                {  
                    id:"0",
                    name: "立即抽奖",
                    OfferID:"",
                    imgUrl:"https://cms.dafang24.com/aliapp/20200825/goDraw.png"
                },
                {  
                    id:"4",
                    name: "10元无门槛券",
                    OfferID: "0",
                    imgUrl:"https://cms.dafang24.com/aliapp/20200825/ten.png"
                },
               {  
                    id:"7",
                    name: "5元无门槛券",
                    OfferID: "0",
                    imgUrl:"https://cms.dafang24.com/aliapp/20200825/five.png"
                },
               {  
                    id:"6",
                    name: "谢谢参与",
                    OfferID:"" ,
                    imgUrl:"https://cms.dafang24.com/aliapp/20200825/join.png"
                },
                {  
                    id:"5",
                    name: "30元无门槛券",
                    OfferID: "0",
                    imgUrl:"https://cms.dafang24.com/aliapp/20200825/thirty.png"
                },
            ],
            couponList: [ //领券列表
                { name: "租5天减120元", OfferID: 325},
                { name: "租7天减180元", OfferID: 326},
                { name: "租9天减270元", OfferID: 327}
            ],
            showID:0,
            activeShow:false,
            ruleshow:false,
            luckDrawNum:0,//抽奖次数,
            id:0,//中奖的id
            tips:"",
            adclick:true
        }
    },
    mounted () {
      setTimeout(()=>{
        window.addDrawCount = this.addDrawCount;
        this.getLuckDrawInit();
      },300);
      this.time=parseInt(Math.random()*10)+40
    },
    methods:{
        //初始化活动信息
         async getLuckDrawInit () {
            let res = await luckDrawInit({
                data: { offerID: "332" }
            });
            if( res.Code==100 ){
                let list = res.Data;
                for(var i =0;i<this.prizeList.length;i++){
                    if(this.prizeList[i].name=="5元无门槛券"){
                        this.prizeList[i].OfferID=list[0]
                    }
                    if(this.prizeList[i].name=="10元无门槛券"){
                        this.prizeList[i].OfferID=list[1]
                    }
                    if(this.prizeList[i].name=="20元无门槛券"){
                        this.prizeList[i].OfferID=list[2]
                    }
                    if(this.prizeList[i].name=="30元无门槛券"){
                        this.prizeList[i].OfferID=list[3]
                    }
                }
                this.initCount();
            }
            if( res.Code==17007 ){
                this.flexible.showToast({
                    content: '请登录/注册！',
                    duration: 1200,
                    success: ()=>{
                    // console.log('调用原生方法跳转登录');
                    if( orderSource==17 ){
                        window.webkit.messageHandlers.openPage.postMessage(JSON.stringify({type: "app", url: "/LonginActivity"}));
                    } else if ( orderSource==16 ){
                            dfpanda.openPage(JSON.stringify({type: "app", url: "/app/LonginActivity"}));
                        }
                    }
                });
            }
        },
        getActivityDiscount(type=0){
            if( localStorage.getItem('token') ){
                let couponList = this.couponList;
                this.consumerCouponsFn(couponList);
            } else {
                this.flexible.showToast({
                    content: '请登录/注册！',
                    duration: 1200,
                    success: ()=>{
                    //console.log()
                    //console.log('调用原生方法跳转登录');
                    if( orderSource==17 ){
                        window.webkit.messageHandlers.openPage.postMessage(JSON.stringify({type: "app", url: "/LonginActivity"}));
                    } else if ( orderSource==16 ){
                        dfpanda.openPage(JSON.stringify({type: "app", url: "/app/LonginActivity"}));
                    }
                    }
                });
            }
        },
        goHome () {
            if( orderSource==17 ){
                window.webkit.messageHandlers.goHome.postMessage(null);
            } else if ( orderSource==16 ){
                dfpanda.goHome();
            }
        },
        goMyPrize () { // 我的奖品
            // this.$router.replace({name: 'couponlist'});
            let _url = mySelfURL +  '/couponlist';
            if( orderSource==17 ){
            window.webkit.messageHandlers.openPage.postMessage(JSON.stringify({type: "html", url: _url}));
            } else if ( orderSource==16 ){
            dfpanda.openPage(JSON.stringify({type: "html", url: _url}));
            }
        },
        async consumerCouponsFn (copList) { // 获取用户优惠券
            let res = await getConsumerCoupons();
            if( res.Code==100 ){
                let uCoupon = res.Data || [];
                if( uCoupon.length ){
                for( let i in uCoupon ){
                    for( let j in copList ){
                        if( uCoupon[i].OfferID == copList[j].OfferID ){
                            copList.splice(j, 1)
                        }
                    }
                }
                }
                if( copList.length ){
                let lastRes = false;
                console.log(copList)
                for( let item of copList ){
                    let gRes = await this.getDrawCoupon(item.OfferID);
                    console.log(gRes)
                    if( gRes ){ lastRes = gRes }
                }
                if( lastRes ){
                    this.flexible.showToast({
                    duration:1200,
                    content:'领取成功！去租车',
                    success:()=>{
                        this.goHome()
                    }
                    });
                } else {
                    this.flexible.showToast({content:'领取失败，请重试'})
                }
            } else {
                this.flexible.showToast({
                    duration:1200,
                    content:'领取成功！去租车',
                    success:()=>{
                    this.goHome()
                    }
                })
                }
            }
        },
        async getDrawCoupon ( offerID ) {
            let res = await DrawCoupon({
                data: {
                    OfferID: offerID,
                    orgID: 0
                },
                isLoading: 1,
                loadContent: '获取优惠券...'
            });
            if( res.Code==100 ){
                return true;
            }
            return false;
        },
        //初始化抽奖次数
        async initCount (){
            let res = await getLotteryCount({
                data:{
                    offerId:"332"
                }
            });
            if( res.Code == 100 ){
                this.luckDrawNum = res.Data;
            }
        },
        async addDrawCount(){
            let res = await addLotteryCount({
                data:{
                    offerId:"332"
                }
            });
                if(res.Code == 100){
                    this.initCount();
                    this.flexible.alert({
                        title: '分享成功',
                        content:"获得1次抽奖机会!"
                    });
                    return '分享成功';
                }
                    return '分享失败';
        },
        shareLuckDraw () { // 分享
            let userinfo = localStorage.getItem('userinfo');
            let showname = '大方租车';
            if( userinfo ){
                showname = JSON.parse(userinfo).Name || JSON.parse(userinfo).Telephone
            }
            let _content = JSON.stringify({
                title: showname + '邀您抽取大奖',
                summary: 'Hi，快来抽取租车特惠券吧',
                // pic: 'https://cms.dafang24.com/aliapp/20191012/APPcode.png',
                pic: 'https://cms.dafang24.com/aliapp/banner2020/nationshare.png',
                path: 'pages/rent/rent?cmsUrl=https://cms.dafang24.com/aliapp/20200825/national.html', // 微信小程序路径
                url: 'https://qr.alipay.com/s7x19803e7pxjjanreifj96' // 支付宝小程序
            });
            if( orderSource==17 ){
                window.webkit.messageHandlers.doShare.postMessage(_content);
            } else if ( orderSource==16 ){
                dfpanda.doShare(_content);
            }
        },
        //抽奖
        async godraw(id,type){
            if(type){
                  this.showID=0;
                this.id=0;
                if(id==0&&this.luckDrawNum>0){
                    let res = await luckDraw({
                        data:{ offerID:"332"},
                        isLoading: true,
                        loadContent: "开始抽奖..."
                    });
                    if(res.Code==100){
                        if(res.Data>0){
                            var offerid = res.Data
                                for(var i in this.prizeList){
                                    if(this.prizeList[i].OfferID==offerid){
                                        this.id= this.prizeList[i].id
                                        this.tips="恭喜您抽中【"+this.prizeList[i].name+"】"
                                    }
                                }
                                var time = 24+this.id*1;
                                this.luckDrawNum = this.luckDrawNum-1;
                                this.adclick=false;
                                this.gorun(time);
                        }else{
                                this.luckDrawNum = this.luckDrawNum-1;
                                this.adclick=false;
                                var type = parseInt(Math.random()*10);
                                this.tips ="很遗憾未中奖，再来一次吧~"
                                    if(type>5){
                                        this.gorun(30);

                                    }else{
                                        this.gorun(26);
                                    }
                        }
                    }
                    
                }
            
            if(id==0&&this.luckDrawNum==0){
                this.flexible.showToast({
                        duration:1200,
                        content:'抽奖次数已用完，分享可获取更多抽奖机会哟~',
                        success:()=>{
                    }
                });
            }
            }else{
                return;
            }
          
        },
        gorun(time){
                this.showID++;
                this.showID = (this.showID > 8) ? (this.showID - 8) : this.showID;
                time--;
                if(time==0){
                     this.flexible.showToast({
                        duration:1200,
                        content:this.tips,
                        success:()=>{
                            this.adclick=true;
                    }
                        });
                }else{
                    let that = this;
                    setTimeout(function(){
                        that.gorun(time);
                }, 1000.00/time);
            }
        },
        goactive(){
            this.activeShow=true;
        },
        showrule(){
            this.ruleshow=true;
        },
        colseMeng(){
            this.activeShow=false;
        },
        closerule(){
            this.ruleshow=false;
        }
    }
}
</script>
<style lang="scss" scoped>
     .national {
            position: relative;
        }
            .app .bg {
                width: 100%;
            }

        .noLogin {
            position: fixed;
            top: 42%;
            left: 0;
            width: 100%;
            text-align: center;
            font-size: .4rem;
            display: none;
        }

        .noLogin span {
            padding: 0.18rem 1.2rem;
            border-radius: .1rem;
            background-color: rgba(0, 0, 0, .6);
            color: #fff;
        }
        .btn {
            position: absolute;
            left: 0;
            width: 100%;
            text-align: center;
        }
        .btn a ,.btn2 a ,.btn3 a {
            display: inline-block;
            /*background-color: rgba(0,0,0,0.4);*/
        }
        .btn1 { 
            top: 10.5rem; 
        }
        .btn4{
            top: 19.5rem;
        }
        .btn1 a,.btn4 a {
            width: 6rem;
            height: 3rem;
        }
        .btn2 { 
            position: absolute;
            top: 14.9rem;
            left:1.7rem;
         }
        .btn2 a {
            width: 1.98rem;
            height: 0.58rem; 
            
            }
        .btn3 { 
            position: absolute;
            top: 15rem;
            left:3.8rem;
         }
        .btn3 a {
            width: 1.98rem;
            height: 0.58rem; 
        }
    .titlebg{
        position: relative;
        left:0;
        top:0;
    }        
    .titlebg .bg{
        width:100%;
        height:100%;
    }   
    .titlebg .btn{
        position: absolute;
        top:23.9rem;
        left:2.3rem;
        width:5.8rem;
        height:1.4rem;
        background:rgba(255,250,186,1);
        opacity:1;
        border-radius:36px;
        line-height: 1.4rem;
        text-align: center;
        font-size:0.75rem;
        color:rgba(4,108,102,1);
    } 
    .drawContent{
        position: relative;
    }
    .drawContent .drawBtn{
        position: absolute;
        width:5rem;
        height:1.15rem;
        top:14rem;
        left:2.6rem;
    }
    .drawContent .drawBtn img{
        width:100%;
        height:100%;
    }
    .drawContent .btnBox{
        position: absolute;
        overflow: hidden;
        top:2.65rem;
        left:2.5rem;
    }
    .drawContent .btnBox img{
        float: left;
        width:2.4rem;
        height:0.7rem;
        padding-top:0.05rem;
    }
    .prizeBox{
        width:8.7rem;
        height:5rem;
        position: absolute;
        top:3.98rem;
        left:1.17rem;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
   .prizeBox .prize{
       width:190px;
       height:130px;
   }
   .prizeBox .prize img{
        width:180px;
        height:115px;
        display: inline-block;
        padding:0.05rem 0.1rem;
   }
    .chance{
        position: absolute;
        font-size:32px;
        color:#0E78FF;
        top:9.7rem;
        left:3.2rem;
        font-family:Source Han Sans CN;
        font-weight:400;
    }
    .share{
        width: 5.4rem;
        height:0.91rem;
        position: absolute;
        top:10.89rem;
        left: 2.25rem;
    }
    .share img{
        width:100%;
        height:100%;
    }
    .activeRule{
        position: absolute;
        right:0;
        top:4.14rem;
    }
    .activeRule img{
        width: 0.84rem;
        height:2.1rem;
    }
    .mantle{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 11000;
    }
    .mantle .mengmeng{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
    }
    .mantleDetail{
        position: absolute;
        left: 11%;
        height:670px;
        overflow: hidden;
        overflow-y: scroll;
        top: 50%;
        width: 80%;
        transform: translateY(-50%);
        background-color: #fff;
        border-radius: 10px;
        box-sizing: border-box;
        text-align: left;
        font-size: 22px;
        //color:rgba(0,0,255);
    }
    .mantleDetail div,.mantleDetail p{
        margin-top:0.15rem;
    }
    .active{
        background-image: url(https://cms.dafang24.com/aliapp/20200825/borderImg.png);
        background-size:100% 100%;
    }
    
</style>